import { ScheduleMessage } from '../../../../../types/ScheduleMessage';

export const isCurrentPort = (stop: ScheduleMessage): boolean => {
    const now = Date.now();
    const eta = new Date(stop.eta).getTime();
    const etd = new Date(stop.etd).getTime();
    return eta <= now && now <= etd;
};
